import { WithFetchDatasByIdFromCMS } from 'modules/shared-cms/hocs';

import { QUERY } from './showroom-query';
import { ShowroomLoader } from './showroom-component-loader';
import { ShowroomProps } from './showroom-type';

const enhancer = WithFetchDatasByIdFromCMS<ShowroomProps>(QUERY, ShowroomLoader, 'findShowroomContent');
export default enhancer;
